var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from 'lit/decorators.js';
import { html } from 'lit';
import { BwElement } from './base/bw-element.js';
// bw-play-button / bw-rec-button used in render — import for side-effect
// (custom-element registration in consumer bundles).
import './bw-play-button.js';
import './bw-rec-button.js';
const DEFAULT_TIME = {};
// Design-system prev/next/stop glyphs (Сергей's icon set). Fade keeps its analog glyph.
const ICON_PREV = `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.4713 18.8183C16.6128 18.8585 16.0701 18.4907 15.3692 18.0911L14.4286 17.5619L11.279 15.7776L9.54439 14.7948C9.24431 14.6255 8.7893 14.3862 8.52169 14.1981C8.21026 13.978 7.94873 13.6972 7.75355 13.3733C7.38692 12.7542 7.28697 11.9702 7.47552 11.2801C7.60027 10.8063 7.85846 10.3762 8.22042 10.0387C8.60658 9.67325 9.48775 9.22719 9.99236 8.94186L12.4423 7.55543L14.9809 6.11542C15.3305 5.91842 15.9862 5.52701 16.337 5.38324C16.5963 5.27815 16.8704 5.21207 17.1499 5.18727C17.8847 5.13004 18.6131 5.35705 19.179 5.81922C19.7364 6.27659 20.085 6.93208 20.148 7.64122C20.1897 8.14915 20.1653 8.97769 20.165 9.50396L20.1644 12.8372L20.1649 15.1468C20.1655 15.5379 20.1891 16.2206 20.1254 16.578C20.0394 17.0513 19.8254 17.4934 19.5056 17.8583C18.9661 18.4753 18.2829 18.7553 17.4713 18.8183Z"/><rect x="5.27295" y="20" width="1.57129" height="16" rx="0.785644" transform="rotate(180 5.27295 20)"/></svg>`;
const ICON_NEXT = `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M6.97402 5.18174C7.83251 5.14148 8.37516 5.50935 9.07608 5.90886L10.0167 6.43814L13.1663 8.22244L14.9009 9.20523C15.201 9.37451 15.656 9.61376 15.9236 9.80189C16.235 10.022 16.4966 10.3028 16.6918 10.6267C17.0584 11.2458 17.1583 12.0298 16.9698 12.7199C16.845 13.1937 16.5869 13.6238 16.2249 13.9613C15.8387 14.3267 14.9576 14.7728 14.4529 15.0581L12.003 16.4446L9.46441 17.8846C9.11478 18.0816 8.45909 18.473 8.10834 18.6168C7.849 18.7219 7.5749 18.7879 7.29536 18.8127C6.56058 18.87 5.83216 18.6429 5.26633 18.1808C4.70893 17.7234 4.36029 17.0679 4.29733 16.3588C4.25562 15.8508 4.28 15.0223 4.2803 14.496L4.28091 11.1628L4.28043 8.85322C4.27981 8.46205 4.25617 7.77943 4.31995 7.42199C4.40594 6.94869 4.61995 6.50659 4.93976 6.14169C5.47926 5.52473 6.16244 5.24472 6.97402 5.18174Z"/><rect x="20.7437" y="20" width="1.57129" height="16" rx="0.785644" transform="rotate(180 20.7437 20)"/></svg>`;
const ICON_STOP = `<svg viewBox="0 0 24 24" fill="currentColor"><rect x="2.34424" y="2.63965" width="19.311" height="19.3447" rx="3"/></svg>`;
// Fade-out → 'decrease/down' glyph (Сергей's songDown), replaces the funnel.
const ICON_FADE = `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M6.93855 20.4131H17.0547C20.0319 20.4131 21.5242 16.8148 19.4209 14.7078L9.30471 4.57395C7.19937 2.46493 3.59521 3.95597 3.59521 6.93597V17.0698C3.59521 18.9163 5.09208 20.4131 6.93855 20.4131Z"/></svg>`;
function fmtTimeCs(seconds) {
    const t = seconds == null || seconds < 0 ? 0 : seconds;
    const mm = String(Math.floor(t / 60)).padStart(2, '0');
    const ss = String(Math.floor(t % 60)).padStart(2, '0');
    const cs = String(Math.floor((t % 1) * 100)).padStart(2, '0');
    return { mm, ss, cs };
}
function fmtTimeMmSs(seconds) {
    const t = seconds == null || seconds < 0 ? 0 : seconds;
    const mm = String(Math.floor(t / 60)).padStart(2, '0');
    const ss = String(Math.floor(t % 60)).padStart(2, '0');
    return `${mm}:${ss}`;
}
let BwTransport = class BwTransport extends BwElement {
    constructor() {
        super(...arguments);
        this.mode = 'rehearsal';
        this.playing = false;
        this.recording = false;
        this.loading = false;
        this.playDisabled = false;
        this.recDisabled = false;
        this.recTooltip = '';
        this.stopDisabled = false;
        this.hasPrev = false;
        this.hasNext = false;
        this.time = DEFAULT_TIME;
        this.masterVolume = 1.0;
        this.masterVu = 0;
        this._onBarCounterClick = (e) => {
            e.stopPropagation();
            this.dispatchEvent(new CustomEvent('bw-bar-counter-click', { bubbles: true, composed: true }));
        };
        this._onBarCounterKeydown = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                this.dispatchEvent(new CustomEvent('bw-bar-counter-click', { bubbles: true, composed: true }));
            }
        };
        this._onMasterInput = (e) => {
            e.stopPropagation();
            const detail = e.detail;
            this.dispatchEvent(new CustomEvent('bw-master-volume-input', {
                detail: { value: detail.value }, bubbles: true, composed: true,
            }));
        };
        this._onMasterChange = (e) => {
            e.stopPropagation();
            const detail = e.detail;
            this.dispatchEvent(new CustomEvent('bw-master-volume-change', {
                detail: { value: detail.value }, bubbles: true, composed: true,
            }));
        };
        this._onPlay = (e) => {
            e.stopPropagation();
            this.dispatchEvent(new CustomEvent('bw-play', { bubbles: true, composed: true }));
        };
        this._onStop = (e) => {
            e.stopPropagation();
            this.dispatchEvent(new CustomEvent('bw-stop', { bubbles: true, composed: true }));
        };
        this._onRec = (e) => {
            e.stopPropagation();
            this.dispatchEvent(new CustomEvent('bw-rec', { bubbles: true, composed: true }));
        };
        this._onFadeOut = (e) => {
            e.stopPropagation();
            this.dispatchEvent(new CustomEvent('bw-fade-out', { bubbles: true, composed: true }));
        };
        this._onPrev = (e) => {
            e.stopPropagation();
            this.dispatchEvent(new CustomEvent('bw-prev', { bubbles: true, composed: true }));
        };
        this._onNext = (e) => {
            e.stopPropagation();
            this.dispatchEvent(new CustomEvent('bw-next', { bubbles: true, composed: true }));
        };
    }
    render() {
        const isRehearsal = this.mode === 'rehearsal';
        return html `
      <div class="bw-tr-buttons">
        <bw-button
          data-role="transport"
          data-action="prev"
          size="lg"
          aria-label="Previous song"
          ?disabled=${!this.hasPrev}
          @click=${this._onPrev}
        >
          <span .innerHTML=${ICON_PREV}></span>
        </bw-button>
        <bw-button
          data-role="transport"
          data-action="stop"
          size="lg"
          aria-label="Stop"
          ?disabled=${this.stopDisabled}
          @click=${this._onStop}
        >
          <span .innerHTML=${ICON_STOP}></span>
        </bw-button>
        <bw-play-button
          data-action="play"
          size="lg"
          ?playing=${this.playing}
          ?loading=${this.loading}
          ?disabled=${this.playDisabled}
          @bw-play-click=${this._onPlay}
        ></bw-play-button>
        ${isRehearsal
            ? html `<bw-rec-button
              data-action="rec"
              size="md"
              ?recording=${this.recording}
              ?disabled=${this.recDisabled}
              tooltip=${this.recDisabled && this.recTooltip ? this.recTooltip : ''}
              @bw-rec-click=${this._onRec}
            ></bw-rec-button>`
            : html `<bw-button
              data-role="transport"
              data-action="fade-out"
              size="lg"
              aria-label="Fade out"
              @click=${this._onFadeOut}
            >
              <span .innerHTML=${ICON_FADE}></span>
            </bw-button>`}
        <bw-button
          data-role="transport"
          data-action="next"
          size="lg"
          aria-label="Next song"
          ?disabled=${!this.hasNext}
          @click=${this._onNext}
        >
          <span .innerHTML=${ICON_NEXT}></span>
        </bw-button>
      </div>
      <div class="bw-tr-timeline">
        <span class="bw-tr-curr">${(() => {
            const { mm, ss, cs } = fmtTimeCs(this.time.current);
            return html `${mm}:${ss}<span class="dim">.${cs}</span>`;
        })()}</span>
        <span class="bw-tr-bar-meta">
          <span
            class="bw-tr-bar-counter"
            role="button"
            tabindex="0"
            aria-label="Bar counter — click to open bar offset"
            @click=${this._onBarCounterClick}
            @keydown=${this._onBarCounterKeydown}
          >${this.time.barCounter ?? 'Bar 1.1'}</span>
          <span class="bw-tr-bar-sep">/</span>
          <span class="bw-tr-total">${fmtTimeMmSs(this.time.total)}</span>
        </span>
      </div>
      <div class="bw-tr-master">
        <bw-volume-bar
          class="bw-tr-mstr-fader"
          size="lg"
          .value=${this.masterVolume}
          .vu=${this.masterVu}
          @bw-input=${this._onMasterInput}
          @bw-change=${this._onMasterChange}
        ></bw-volume-bar>
      </div>
    `;
    }
};
__decorate([
    property({ type: String, reflect: true })
], BwTransport.prototype, "mode", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwTransport.prototype, "playing", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwTransport.prototype, "recording", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwTransport.prototype, "loading", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'play-disabled' })
], BwTransport.prototype, "playDisabled", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'rec-disabled' })
], BwTransport.prototype, "recDisabled", void 0);
__decorate([
    property({ type: String, attribute: 'rec-tooltip' })
], BwTransport.prototype, "recTooltip", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'stop-disabled' })
], BwTransport.prototype, "stopDisabled", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'has-prev' })
], BwTransport.prototype, "hasPrev", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'has-next' })
], BwTransport.prototype, "hasNext", void 0);
__decorate([
    property({ attribute: false })
], BwTransport.prototype, "time", void 0);
__decorate([
    property({ type: Number, attribute: 'master-volume' })
], BwTransport.prototype, "masterVolume", void 0);
__decorate([
    property({ type: Number, attribute: 'master-vu' })
], BwTransport.prototype, "masterVu", void 0);
BwTransport = __decorate([
    customElement('bw-transport')
], BwTransport);
export { BwTransport };
//# sourceMappingURL=bw-transport.js.map